export const URLS = {
	ASSETS: "/assets",
	COURSE_CHAPTER_SECTION_LESSONS: "/course-chapter-section-lessons",
	COURSE_CHAPTER_SECTIONS: "/course-chapter-sections",
	COURSE_CHAPTERS: "/course-chapters",
	COURSES: "/courses",
	COUNTRIES: "/countries",
	FILES: "/files",
	FILEVAULTFOLDER: "/folders",
	GET_IMAGE_URL: "/image-url",
	LESSON_DRAFTS: "/lesson-drafts",
	LESSON_RANKS: "/lesson-ranks",
	LESSON_TYPES: "/lesson-types",
	LESSON_VIDEOS: "/lesson-videos",
	LESSONS: "/lessons",
	QUESTION_ANSWER_OPTIONS: "/question-answer-options",
	QUESTION_DIFFICULTY_LEVELS: "/question-difficulty-levels",
	QUESTION_TYPES: "/question-types",
	QUESTIONS: "/questions",
	REPORTS: "/reports",
	SCHOOLS: "/schools",
	SUBJECT_LESSONS: "/subject-lessons",
	SUBJECTS: "/subjects",
	UPLOAD: "/upload",
	USER_CUSTOM_TESTS: "/user-custom-tests",
	USERS: "/users",
	LOCATION_PACKAGE: "/location-package",
	LOCATIONS: "/locations",
	SUBJECT_CATEGORIES: "/subject-categories",
	USER_SUBSCRIPTION_TYPES: "/user-subscription-types",
	COUPONS: "/coupons",
	NOTIFICATIONS: "/notifications"
};
